<template>
  <div id="app" class="screen-wrapper">
    <tool-bar-new v-if="showToolBarNew"></tool-bar-new>
    <router-view :scale="scale"></router-view>
    <el-tooltip v-if="showChangeLanguage" class="item" effect="dark" :content="$i18n.locale === 'en' ? $t('French') : $t('English')" placement="top-start">
      <img class='changeLanguage' :src="require('@/assets/language.png')" :alt="$t('changeLanguage')" @click="changeLanguage"/>
    </el-tooltip>
  </div>
</template>

<script>
import ToolBar from '@/components/ToolBar.vue'
import ToolBarNew from '@/components/ToolBarNew.vue'

export default {
  name: 'App',
  components: {
    ToolBar,
    ToolBarNew
  },
  data () {
    return {
      scale: 1
    }
  },
  computed: {
    showToolBar () {
      // 在 Home、Landing 等页面不显示顶部工具栏（由落地页自己的导航顶替）
      const hideInRoutes = ['Teachers', 'Home', 'Landing', 'About', 'loginNew', 'registerNew']
      return !hideInRoutes.includes(this.$route.name)
    },
    showToolBarNew () {
      // 在登录和注册页面不显示工具栏
      const hideInRoutes = ['studentHomepage', 'parentOrTeacher', 'studentLearn', 'studentQuiz', 'quizResults', 'teacherManagement', 'pointLearn', 'quizHistorical', 'billing', 'Verify', 'VerifyEmail', 'VerifyActivated', 'creditCard']
      return hideInRoutes.includes(this.$route.name)
    },
    showChangeLanguage () {
      // 只有在登录和注册页面显示语言切换按钮
      const showInRoutes = ['Landing', 'About', 'Teachers']
      return !showInRoutes.includes(this.$route.name)
    }
  },
  mounted () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      const actualHeight = window.innerHeight - 80
      const standardHeight = 1080
      this.scale = actualHeight / standardHeight
    },
    changeLanguage () {
      this.$i18n.locale = this.$i18n.locale === 'en' ? 'fr' : 'en'
    }
  }
}
</script>

<style>
.screen-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(180deg, #f3e8ff 0%, #ede7f6 40%, #e8e0f5 100%);
  /* 注意：不要设置 overflow: hidden，否则可能裁剪内容 */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  cursor: default;
  display: flex;
  flex-direction: column;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
.changeLanguage{
  position: absolute;
  right: 16px;
  bottom: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.el-tooltip__popper.is-dark{
  font-family: 'AzonixRegular', sans-serif !important;
}
</style>
